import React, { Fragment, useContext } from 'react'
import { Dropdown, Image, Menu } from 'semantic-ui-react'
import { RootStoreContext } from '../../App/stores/RootStore';
import RoleRules from '../../App/enumerable/RolesRules';
import { observer } from "mobx-react-lite";
import {useMsal} from "@azure/msal-react";

const UserInfo: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { user, HasRoles } = rootStore.userStore;
    const { getSelfTestResults } = rootStore.selfTestStore;
    const { instance, accounts } = useMsal();
    return (
        <Fragment>
            <Menu.Item position='right'>
                <Image avatar spaced='right' className={'profile-img'} src={`data:image/png;base64,${user?.image}`} />
                <Dropdown pointing='top right' text={user?.displayName}>
                    <Dropdown.Menu>
                        {HasRoles(RoleRules.SystemAdmin) ?
                            <Dropdown.Item onClick={getSelfTestResults} text='Self Test' icon='heartbeat' />: ""}
                        {HasRoles(RoleRules.SystemAdmin) ?
                            <Dropdown.Divider />: ""}
                        <Dropdown.Item onClick={()=>instance.logout()} text='Logout' icon='power' />
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Item>
        </Fragment>
    );
}

export default observer(UserInfo)